module.exports = __webpack_public_path__ + "assets/alertCircle-d14179.svg";